function Image({ width, height, className, source, alternativetext, caption }) {
  return (
    <>
      <img
        width={width || "auto"}
        height={height || "auto"}
        className={className}
        src={source}
        alt={alternativetext}
        referrerPolicy="no-referrer"
      />
      {caption && <p className="image-caption text-muted">{caption}</p>}
    </>
  );
}

export default Image;
